<template>
  <v-card class="mx-auto">
    <v-card-text class="pa-5 black--text">
      <v-row class="mx-2 my-3">
        <v-col cols="12">
          <div class="font-weight-medium mb-2" style="font-size: 20px">
            Informasi Kegiatan (Pelaksanaan)
          </div>
          <v-row>
            <v-col cols="12" lg="4">
              <div class="grey--text body-2">Nama Kegiatan</div>
              <div class="black--text body-1">
                {{ $getDeepObj(info, 'kegiatan.0') || '' }}
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="grey--text body-2">Angkatan Pelaksanaan</div>
              <div class="black--text body-1">Angkatan {{ info.gelombang }}</div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="grey--text body-2">Waktu Pelaksanaan</div>
              <div class="black--text body-1">
                {{ $getDeepObj(info, 'kegiatan.1') || '' }}
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <div class="font-weight-medium mb-1" style="font-size: 20px">Informasi Daerah Pelaksanaan</div>
          <v-row no-gutters>
            <v-col cols="12" lg="6" v-for="(sasaran, id) in sasarans" :key="id">
              <v-list-item class="px-0">
                <v-list-item-avatar class="my-1" color="grey">
                  <span class="title white--text">
                    {{ id + 1 }}
                  </span>
                </v-list-item-avatar>
                <v-list-item-content>
                  <div class="body-2 grey--text">Nama Daerah</div>
                  <div class="body-1">
                    {{ $getDeepObj(sasaran, 'm_kota.data.keterangan') }} -
                    {{ $getDeepObj(sasaran, 'm_propinsi.data.keterangan') }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <div class="font-weight-medium mb-1" style="font-size: 20px">Informasi Pelaksanaan</div>
          <base-form-generator :schema="schema" v-model="form" class="pt-4" />
          <v-row>
            <v-col cols="12" lg="6">
              <div class="grey--text body-2">Tantangan Pelaksanaan Kegiatan (Bisa memilih lebih dari 1)</div>
              <template v-for="(tantangan, id) in this.masters.tantangan || []">
                <v-checkbox
                  v-model="form.k_tantangan_psp"
                  dense
                  class="mt-1"
                  hide-details
                  :key="id"
                  :value="tantangan.k_kp_opsi_psp"
                >
                  <template v-slot:label>
                    <span class="black--text">{{ tantangan.keterangan }}</span>
                  </template>
                </v-checkbox>
              </template>
            </v-col>
            <v-col v-show="form.k_tantangan_psp.includes(59)" cols="12" lg="6">
              <div class="grey--text body-2 mb-1">Tantangan Pelaksanaan Kegiatan (Lain - lain)</div>
              <div>
                <v-text-field v-model="form.tantangan_lain" outlined dense placeholder="Tuliskan tantangan lainnya" />
              </div>
            </v-col>
            <v-col cols="12">
              <div class="grey--text body-2 mb-1">Deskripsi Tantangan</div>
              <div>
                <v-textarea
                  v-model="form.deskripsi_pelaksanaan"
                  outlined
                  dense
                  hide-details
                  rows="3"
                  auto-grow
                  placeholder="Tuliskan deskripsi tantangan"
                />
              </div>
            </v-col>
            <v-col cols="12">
              <div class="font-weight-medium mb-2" style="font-size: 20px">
                Lampiran Dokumentasi Kegiatan
              </div>
              <v-row class="mt-1">
                <v-col v-if="(berkases || []).length" cols="12" sm="12" md="12" class="pt-1">
                  <v-row v-for="(file, f) in berkases" :key="f" dense>
                    <v-col cols="12" md="9" sm="12">
                      <div class="grey lighten-3 pa-2 black--text">{{ file.judul }}</div>
                    </v-col>
                    <v-col cols="12" md="3" sm="12" class="my-auto">
                      <div>
                        <v-btn color="success" depressed :href="file.url_berkas" target="_blank">
                          <v-icon left>mdi-eye</v-icon>
                          Lihat
                        </v-btn>
                        <v-btn class="mx-1" color="red" dark depressed @click="onDelBerkas(file)">
                          <v-icon left>mdi-delete</v-icon>
                          Hapus
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="py-0 mb-4">
                  <v-btn color="primary" depressed :disabled="berkases.length >= 5" @click="onAddBerkas">
                    <v-icon left>mdi-plus</v-icon> Tambah Berkas
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <form-berkas ref="berkas" jenis="dokumentasi" title="Dokumentasi Kegiatan" @upload="onAddBerkasSave" />
  </v-card>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import FormBerkas from './Berkas';
import { mapActions } from 'vuex';

export default {
  name: 'LokakaryaDinasPelaksanaan',
  components: { BaseFormGenerator, FormBerkas },
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    info: {
      type: Object,
      default: () => {},
    },
    berkases: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    schema() {
      return [
        {
          type: 'VDatePicker',
          name: 'tgl_mulai_pelaksanaan',
          label: 'Tanggal Mulai Pelaksanaan',
          labelColor: 'grey',
          usePrependInnerIcon: 'mdi-calendar-month',
          hint: 'wajib diisi',
          outlined: true,
          singleLine: true,
          disabled: this.readOnly,
          hideDetails: true,
          dense: true,
          grid: { cols: 12, md: 3, sm: 12 },
        },
        {
          type: 'VDatePicker',
          name: 'tgl_selesai_pelaksanaan',
          label: 'Tanggal Selesai Pelaksanaan',
          labelColor: 'grey',
          usePrependInnerIcon: 'mdi-calendar-month',
          hint: 'wajib diisi',
          outlined: true,
          singleLine: true,
          disabled: this.readOnly,
          hideDetails: true,
          dense: true,
          grid: { cols: 12, md: 3, sm: 12 },
        },
        {
          type: 'VTextField',
          name: 'jml_pa',
          label: 'Jumlah Fasilitator',
          labelColor: 'grey',
          hint: '',
          mask: '###',
          required: false,
          outlined: true,
          singleLine: true,
          dense: true,
          grid: { cols: 12, md: 3, sm: 12 },
        },
        {
          type: 'VTextField',
          name: 'jml_peserta',
          label: 'Jumlah Peserta',
          labelColor: 'grey',
          hint: '',
          mask: '###',
          required: false,
          outlined: true,
          singleLine: true,
          dense: true,
          grid: { cols: 12, md: 3, sm: 12 },
        },
      ];
    },
    sasarans() {
      return this.$getDeepObj(this.info, 'detail.psp_kp_pa_lokakarya_dinas_sasarans.data') || [];
    },
  },
  data() {
    return {
      form: { k_tantangan_psp: [] },
    };
  },
  methods: {
    ...mapActions('lokakaryaDinas', ['upload', 'delete']),

    reset() {
      this.$set(this, 'form', { k_tantangan_psp: [] });

      const detail = this.info.detail || {};
      for (const sch of this.schema) {
        this.$set(this.form, sch.name, detail[sch.name] || '');
      }

      const tantangans = this.$getDeepObj(detail, 'psp_kp_pa_lokakarya_dinas_tantangans.data') || [];
      const tantangansData = tantangans.map((tantangan) => {
        return tantangan.k_tantangan_psp;
      });
      const tantanganKeterangan = tantangans.filter((tantangan) => !!tantangan.keterangan);

      this.$set(this.form, 'deskripsi_pelaksanaan', detail['deskripsi_pelaksanaan'] || '');
      this.$set(this.form, 'k_tantangan_psp', tantangansData);
      this.$set(this.form, 'tantangan_lain', (tantanganKeterangan[0] && tantanganKeterangan[0]['keterangan']) || '');
      this.$set(this.form, 'k_propinsi', detail['k_propinsi'] || '');
      this.$set(this.form, 'k_kota', detail['k_kota'] || '');
    },

    getValue() {
      let params = Object.assign({ jenis: 'pelaksanaan', k_lokakarya_kegiatan_psp: this.info.k_laporan }, this.form);

      params['tantangan'] = params.k_tantangan_psp.map((kTantangan) => {
        return {
          k_tantangan_psp: kTantangan,
          keterangan: +kTantangan === 59 ? params.tantangan_lain : '',
        };
      });

      delete params['k_tantangan_psp'];
      delete params['tantangan_lain'];

      return params;
    },

    onAddBerkas() {
      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    onAddBerkasSave(berkas) {
      const params = new FormData();
      const detail = this.info.detail || {};
      const id = detail.psp_kp_pa_lokakarya_dinas_id;

      params.append('label', 'dokumentasi');
      params.append('judul', berkas.judul);
      params.append('file', berkas.file);
      params.append('k_lokakarya_kegiatan_psp', this.info.k_laporan);

      this.$refs.berkas.startLoading();
      this.upload({ id, params })
        .then(() => {
          this.$emit('refresh', this.info.detail);
          this.$refs.berkas.close();
          this.$refs.berkas.stopLoading();
        })
        .catch(() => {
          this.$refs.berkas.stopLoading();
        });
    },

    onDelBerkas(berkas) {
      const id = this.$getDeepObj(berkas, `psp_kp_pa_lokakarya_dinas_berkas_id`);
      this.$confirm(`Apakah Anda yakin ingin menghapus berkas <b>${berkas.judul}</b> ?`, 'Peringatan', {
        tipe: 'error',
      }).then(() => {
        this.delete({ id }).then(() => {
          this.$success('Berkas berhasil di hapus');
          this.$emit('refresh', this.info.detail);
        });
      });
    },
  },
};
</script>
